export const LKG = 1;
export const CF = 2;